export const contactsData = {
    name: 'A. S. M Rafiqullah',
    phone: '+88 01716706061',
    email: 'asmrsaeed@gmail.com',
    address: 'Tangail, Bangladesh',
    message: '',

    sheetAPI: 'https://sheetdb.io/api/v1/foyqj4q3j4vru'
}